/* Le filtre agit seulement sur le catalogue local ; tous les produits restent visibles sans JavaScript. */
(() => {
  const buttons = [...document.querySelectorAll('[data-family-filter]')];
  const cards = [...document.querySelectorAll('[data-family-group]')];
  if (!buttons.length || !cards.length) return;
  buttons.forEach(button => button.addEventListener('click', () => {
    const selected = button.dataset.familyFilter;
    buttons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
    cards.forEach(card => { card.hidden = selected !== 'all' && card.dataset.familyGroup !== selected; });
  }));
})();
